/* tslint:disable */

declare var Object: any;
export interface StandardizedServiceInterface {
  "id"?: number;
}

export class StandardizedService implements StandardizedServiceInterface {
  "id": number;
  constructor(data?: StandardizedServiceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `StandardizedService`.
   */
  public static getModelName() {
    return "StandardizedService";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of StandardizedService for dynamic purposes.
  **/
  public static factory(data: StandardizedServiceInterface): StandardizedService{
    return new StandardizedService(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'StandardizedService',
      plural: 'StandardizedServices',
      path: 'StandardizedServices',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/StandardizedService.ts